import { render, staticRenderFns } from "./ZopIm.vue?vue&type=template&id=4978fadf&lang=pug&"
import script from "./ZopIm.vue?vue&type=script&lang=js&"
export * from "./ZopIm.vue?vue&type=script&lang=js&"
import style0 from "./ZopIm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4978fadf')) {
      api.createRecord('4978fadf', component.options)
    } else {
      api.reload('4978fadf', component.options)
    }
    module.hot.accept("./ZopIm.vue?vue&type=template&id=4978fadf&lang=pug&", function () {
      api.rerender('4978fadf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ZopIm.vue"
export default component.exports